module.exports = __webpack_public_path__ + "ce4be335868349e42d5fd3e75f3dd48a.MP3";